import {http} from '../../plugins/http';

export default {

    index(params) {
        return http.get('/api/v1/absences/absence', {
            params: params
        });
    },

    countPendingVacations() {
        return http.get('/api/v1/absences/absence/count-pending-vacations');
    },

    store(absence) {
        return http.post(`/api/v1/absences/absence`, absence);
    },

    edit(absence) {
        return http.get(`/api/v1/absences/absence/${absence}/edit`);
    },

    update(absence, params) {
        return http.patch(`/api/v1/absences/absence/${absence}`, params);
    },

    destroy(absence) {
        return http.delete(`/api/v1/absences/absence/${absence}`);
    },

    approve(absence) {
        return http.post(`/api/v1/absences/absence/${absence}/approve`);
    },

    reject(absence, params) {
        return http.post(`/api/v1/absences/absence/${absence}/reject`, params);
    },

    certificateReceived(absence) {
        return http.post(`/api/v1/absences/absence/${absence}/certificate-received`);
    },

    editVacationEntitlement(user, year) {
        return http.get(`/api/v1/absences/edit-vacation-entitlement/${user}/${year}`);
    },

    saveVacationEntitlement(user, params) {
        return http.post(`/api/v1/absences/save-vacation-entitlement/${user}`, params);
    },

    checkPossibleDuplicateAbsence(params) {
        return http.post(`/api/v1/absences/check-possible-duplicate-absence`, params);
    }

};



// WEBPACK FOOTER //
// ./src/services/Absences/AbsenceController.js